
import {Component, Vue, Watch} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import FromUserInfo from '@/model/modules/FromUserInfo'
import FromUserService from '@/service/modules/FromUserService'
import FromUserEditor from '@/views/module-from-user-manage/from-user-editor.vue'

@Component({
  components: {FromUserEditor}
})
export default class ModuleFromUserManage extends Vue {
  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '数据ID', value: 'id'},
    {text: '名称', value: 'name'},
    {text: '发件人姓名', value: 'fromName'},
    {text: '发件人电话', value: 'fromTel'},
    {text: '发件人地址', value: 'fromAdd'},
    {text: '发件人洲', value: 'fromState'},
    {text: '发件国家', value: 'fromCountry'},
    {text: '发件省份', value: 'fromProvince'},
    {text: '发件城市', value: 'fromCity'},
    {text: '邮政编码', value: 'fromPostcode'},
    {text: '操作', value: 'action', sortable: false}
  ]

  queryLikeResult: BasePageableInfo<FromUserInfo> = new BasePageableInfo<FromUserInfo>()
  queryType: string = 'name'
  queryWord: string = ''
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  mounted() {
    this.refreshAllData()
  }

  @Watch('pageSize')
  refreshAllData() {
    this.listLoadingState = true
    const searchExample = {}
    searchExample[this.queryType] = this.queryWord
    FromUserService.list(searchExample, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<FromUserInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  newItem() {
    this.editItem(new FromUserInfo())
  }

  editItem(item: FromUserInfo) {
    const self = this
    // @ts-ignore
    this.$refs.fromUserEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }
}
